import { Button, Classes, Icon, InputGroup, Position, Spinner, TextArea, Tooltip } from "@blueprintjs/core"
import { PlanrPopover } from "modules/common/components/planr/popover/Popover"
import { findIndex } from "lodash"
import { observer } from "mobx-react"
import { OutsourcerDictionaryType } from "modules/agents/outsourcers/models/outsourcer-dictionary"
import {
  ActualPaymentType,
  OutsourcerPaymentSnapshotType,
  OutsourcerPaymentType,
  outsourcerPaymentFields,
} from "modules/agents/outsourcers/models/outsourcer-payment"
import { FileLink } from "modules/common/components/files/FileLink"
import { FileUploaderHOC } from "modules/common/components/files/Uploader"
import { DatePicker } from "modules/common/components/form/DatePicker"
import { RemoveConfirmation } from "modules/common/components/form/RemoveConfirmation"
import { formatMoney } from "modules/common/components/money/Money"
import { MoneyInput } from "modules/common/components/money/MoneyInput"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { GeneralIcon, GeneralIcons } from "modules/common/components/planr/icon/Generalcon"
import { PlanrTag } from "modules/common/components/planr/tag/PlanrTag"
import { DATE_FORMAT, LARGE_ICON_AS_BUTTON_SIZE } from "modules/common/constants"
import { getDragItemStyle } from "modules/common/services/drag"
import { DefaultSelectedOption, SimpleSelect, renderSingleOption } from "modules/common/services/form/select"
import { onlyDigitsInputKeyPress, preventSubmitKeyDown } from "modules/common/services/form/values"
import { eat } from "modules/common/services/typescript"
import { texts } from "modules/common/texts"
import { OrderSummaryType } from "modules/orders-manage/models/order"
import { EventDateType, EventTypes } from "modules/orders-manage/models/order-events"
import {
  InvoiceFileSnapshotType,
  OrderFileLabel,
  OrderFileSnapshotType,
  OrderFileSorter,
} from "modules/orders-manage/models/order-file"
import { getDebit, outsourcedSpendingFields } from "modules/orders-manage/models/order-spending"
import { IdFactory, UploaderFatory } from "modules/orders-manage/types"
import { Constants } from "modules/root/models/constants"
import moment from "moment"
import React from "react"
import { DraggableProvided } from "@hello-pangea/dnd"
import ReactDOM from "react-dom"
import { NumberFormatValues } from "react-number-format"
import { ActualPaymentSnapshotType } from "../../../../agents/outsourcers/models/outsourcer-payment"
import { SpendingComponents, UnknownEventType } from "../../finance/events/BusinessEvent"
import portal from "../../portal"
import { OrderBase } from "../../summary/OrderBase"
import { OrderFiles } from "../../summary/OrderFiles"
import { OutsourcedOrderSpendingSchema, SPENDING_DEBT, SpendingRowProblems, otherSpendingLabels } from "../../validation"
import { spendingWarningStyles } from "../SpendingWarning"
import styles from "./OutsourcedSpendings.module.scss"
import { OutsourcerSelect } from "./OutsourcerSelect"
import { ActualPaymentMark } from "./ActualPaymentMark"
import { SpendingSaver } from "../spending-saver"
import { ACTUAL_PAYMENTS_BLOCK_NAME, MAIN_DATA_BLOCK_NAME, PLAN_PAYMENTS_BLOCK_NAME } from "./print-view-model"
// import {
//   fields as spendingFields
// } from "modules/orders-manage/models/order"
const digits = onlyDigitsInputKeyPress()
const labels = otherSpendingLabels()
const fields = outsourcedSpendingFields
const schema = OutsourcedOrderSpendingSchema(false)

const OutsourcerOrderLabel = OrderFileLabel("Договор")

export interface PaymentStatusToggler {
  /** переключает статус фин. запроса и возвращает новый статус */
  toggleStatus?: (guid: string) => void | Promise<string | boolean | undefined>
  formDirty: boolean
}

class OutsourcedSpendingRowBase extends React.PureComponent<OutsourcedSpendingRowProps, OutsourcedSpendingRowState> {
  constructor(props: OutsourcedSpendingRowProps) {
    super(props)

    this.state = {
      showClientReturn: false
    }
  }
  renderInternal() {
    const {
      spending,
      onChange,
      paymentFactory,
      formDirty,
      printOrderFile,
      details,
      newIdd,
      dirty,
      allPayments,
      // name
    } = this.props
    const { toggleStatus, readOnly, agents } = this.props
    const { draggable, highlight, disabled } = this.props
    // const { showClientReturn } = this.state
    const outsourcerId = spending[fields.outsourcerId]
    // const content = spending[fields.contentGuid] === "" || spending[fields.contentGuid] === null;

    const agent = agents.asMap[outsourcerId]
    const canPrintPhys = printOrderFile && agent && !agent.isLegalEntity && !agent.selfEmployed
    const canPrintSelf = printOrderFile && agent && agent.selfEmployed
    const changed = !(disabled || readOnly) && this.props.saver.rowChanged(this.props.section, spending)
    // поля, без которых проект не перевести в Завершение/Завершено
    const problems = SpendingRowProblems(spending as any)
    const problem = (field: string) =>
      problems.fields.includes(field) ? spendingWarningStyles.field : ""

    return (
      <div
        ref={draggable.innerRef}
        {...draggable.draggableProps}
        {...draggable.dragHandleProps}
        className={`${styles.row} ${changed ? styles.rowChanged : ""}`}
        style={this.getItemStyle()}
      >
        <div className={styles.rowContent}>
        <div className={styles.left}>
          <div className={styles.one}>
            <div className={styles.wrapper}>
              <div className={styles.one}>


                {/** Выдано \ сдано \ принято */}
                <div className={styles.taskState}>

                  {/* статус задания блокируется наравне с остальными полями строки:
                      иначе кнопки перекрашиваются, а сохранить изменение нечем */}
                  <TaskState spending={spending} readOnly={disabled || readOnly} onChange={onChange} />

                  <div className="status-doc-del">
                    {!(disabled || readOnly) && (
                      <RemoveConfirmation
                        onConfirmed={this.removeRow}
                        what={() => "исполнителя (включая оплаты, договоры и другие данные)"}
                        render={({ confirmRemoving }) => {
                          return (
                            <PlanrButton
                              icon="general-trash"
                              type={"graybtn"}
                              round={true}
                              onClick={confirmRemoving}
                              title={labels[fields.taskAccepted]}
                            />
                          )
                        }}
                      />
                    )}
                  </div>
                </div>

                {/** Сумма и остаток */}
                <div className={styles.mainInfo}>
                  {MAIN_DATA_BLOCK_NAME}
                  <div>
                    {/* {name === spendingFields.otherOrderSpendings && <div className={styles.outsourcer}>
                      <label>Возврат заказчику:</label>  <Switch checked={showClientReturn} onChange={() => { this.setState({ showClientReturn: !this.state.showClientReturn }) }} large={true} disabled={disabled || readOnly} />
                    </div>}
                    {name === spendingFields.otherOrderSpendings && showClientReturn &&
                      <div className={styles.outsourcer}>
                        <label>Выберите платеж:</label>
                        <OutsourcerSelect
                          agents={agents}
                          field={fields.outsourcerId}
                          label={labels[fields.outsourcerId]}
                          onChange={onChange}
                          readOnly={disabled || readOnly}
                          value={outsourcerId}
                          includeClient={true}
                        />
                      </div>} */}
                    <OrderSum
                      spending={spending}
                      readOnly={disabled || readOnly}
                      onChange={onChange}
                      sumClassName={problem(fields.actualSum)}
                      restClassName={problem(SPENDING_DEBT)}
                    >
                      <div style={{ minWidth: "155px" }} className={problem(fields.days)}>
                        <label>Срок выполнения (дни):</label>
                        <InputGroup
                          value={spending[fields.days] ?? ""}
                          onChange={(e: React.FormEvent<HTMLInputElement>) => {
                            const val = parseInt(e.currentTarget.value, 10)
                            onChange(fields.days, isNaN(val) ? null : val)
                          }}
                          className="planr-default-input"
                          autoComplete="off"
                          data-lpignore="true"
                          onKeyDown={preventSubmitKeyDown}
                          onKeyPress={digits}
                          disabled={disabled || readOnly}
                        />
                      </div>
                    </OrderSum>

                    <div className={`${styles.outsourcer} ${problem(fields.outsourcerId)}`}>
                      <label>Исполнитель:</label>
                      <OutsourcerSelect
                        agents={agents}
                        field={fields.outsourcerId}
                        label={labels[fields.outsourcerId]}
                        onChange={onChange}
                        readOnly={disabled || readOnly}
                        value={outsourcerId}
                        includeClient={true}
                      />
                    </div>
                    <div
                      style={{ marginTop: "33px", display: "flex" }}
                      className={problem(fields.orderNumber) || problem(fields.startDate)}
                    >
                      {/* Номер и дата договора */}
                      <OrderBase
                        inline={true}
                        what="Договор"
                        schema={schema}
                        number={spending[fields.orderNumber]}
                        date={spending[fields.startDate]}
                        onChange={onChange}
                        addOrderFile={this.addOrderFile}
                        readOnly={disabled || readOnly}
                        upload={this.props.upload}
                        newId={this.props.newId}
                      >
                        {(canPrintPhys || canPrintSelf) && (
                          <PlanrButton
                            icon="general-import"
                            type={"secondary"}
                            size="small"
                            onClick={this.printOrderFile}
                            title="Составить договор"
                            style={{
                              width: "60px",
                              marginTop: "11px",
                              height: "38px",
                              marginLeft: "12px",
                            }}
                          />
                        )}
                      </OrderBase>
                    </div>
                  </div>
                  <div>
                    {/* Список файлов договоров с подрядчиком */}
                    <div className="order-files-list">
                      <OrderFiles<OrderFileSnapshotType>
                        readOnly={disabled || readOnly}
                        removeLabel={OutsourcerOrderLabel}
                        fileLabel={OutsourcerOrderLabel}
                        sorter={OrderFileSorter}
                        files={spending[fields.orders]}
                        baseUrl={this.props.baseUrl}
                        onRemove={(id) => {
                          const value = spending[fields.orders].filter((f: OrderFileSnapshotType) => f.guid !== id)
                          onChange(fields.orders, value)
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* кнопки появляются, только когда в строке есть несохранённые данные,
                  и стоят под полями блока основных данных */}
              <div className={`${styles.rowButtons} ${changed ? styles.rowButtonsVisible : ""}`}>
                <PlanrButton type="greenish" size="small" onClick={this.saveRow}>
                  {texts.save}
                </PlanrButton>

                <PlanrButton type="graybtn" size="small" onClick={this.cancelRow}>
                  {texts.cancel}
                </PlanrButton>
              </div>
            </div>

            <PlanPayments
              outsourcer={spending[fields.outsourcerId]}
              value={spending[fields.planPayments]}
              actualPayments={spending[fields.actualPayments]}
              factory={paymentFactory}
              onChange={(paymnets) => {
                onChange(fields.planPayments, paymnets)
              }}
              readOnly={readOnly}
              formDirty={formDirty}
              toggleStatus={toggleStatus}
              baseUrl={this.props.baseUrl}
              upload={this.props.upload}
              newIdd={newIdd}
              details={details}
              spendingId={spending[fields.id]}
              spendingRow={spending}
              dirty={dirty}
              allPayments={allPayments}
              highlighted={highlight || ""}
              saver={this.props.saver}
              section={this.props.section}
            />
          </div>
        </div>

        {/* фактическая оплата показывается внутри своего планового платежа; отдельно — только
            старые оплаты (2018–2020), заведённые без плана, и оплаты удалённых плановых */}
        <ActualPayments
          data={orphanActualPayments(spending)}
          highlighted={highlight || ""}
          spendingId={spending[fields.id]}
          actualGuids={actualGuids(spending)}
          saver={this.props.saver}
        />
        </div>

      </div>
    )
  }

  printOrderFile = () => {
    const { spending, printOrderFile } = this.props
    const outsourcerId = spending[fields.outsourcerId]
    let contentGuid = spending[fields.contentGuid] ?? ""
    let comment = spending[fields.comment] ?? ""

    printOrderFile && printOrderFile(outsourcerId, contentGuid, comment)
  };

  /** Сохранить строку затрат отдельно от остального договора */
  saveRow = async () => {
    const { saver, section, spending } = this.props

    await saver.saveRow(section, spending)
  };

  /** Вернуть строку к последнему сохранённому состоянию */
  cancelRow = () => {
    const { saver, section, spending, onReplace, onRemove } = this.props

    const saved = saver.formValues(section, spending)

    // строки ещё нет в базе — отмена просто убирает её из формы
    if (!saved) {
      onRemove()

      return
    }

    onReplace(saved)
  };

  /** Удалить строку на сервере и убрать её из формы */
  removeRow = async () => {
    const { saver, section, spending, onRemove } = this.props

    const removed = await saver.removeRow(section, spending)

    if (removed) {
      onRemove()
    }
  };

  render() {
    const { isDragging } = this.props
    const result = this.renderInternal()

    return isDragging ? ReactDOM.createPortal(result, portal) : result
  }

  getItemStyle = (): React.CSSProperties => {
    const { isDragging, draggable } = this.props
    return getDragItemStyle(isDragging, draggable.draggableProps.style)
  };

  addOrderFile = (file: OrderFileSnapshotType) => {
    const { spending, onChange } = this.props
    const value = spending[fields.orders]
    file.sortOrder = value.length + 1

    onChange(fields.orders, [file, ...value])
  };
}

/** observer нужен, чтобы кнопка сохранения гасла сразу после ответа сервера */
export const OutsourcedSpendingRow = observer(OutsourcedSpendingRowBase)

interface OutsourcedSpendingRowState {
  showClientReturn: boolean
}

interface OutsourcedSpendingRowProps extends PaymentStatusToggler, IdFactory, UploaderFatory {
  name?: string
  dirty: boolean
  disabled: boolean | undefined
  isDragging: boolean
  draggable: DraggableProvided
  spending: TStringMap<any>
  agents: OutsourcerDictionaryType
  onChange: (field: string, value: any) => void
  onReplace: (value: TStringMap<any>) => void
  printOrderFile?: (outsourcerId: string, contentGuid: string, comment: string) => void
  onRemove: () => void
  paymentFactory: OutsourcerPaymentFactory
  readOnly?: boolean
  highlight?: string
  baseUrl: string
  details: OrderSummaryType
  newIdd: () => Promise<string>
  allPayments: ActualPaymentType[]
  saver: SpendingSaver
  section: string
}

/** Фактические оплаты строки */
const actualsOf = (spending: TStringMap<any>): ActualPaymentSnapshotType[] => spending[fields.actualPayments] || []

/** Идентификаторы всех фактических оплат строки — ключ кэша подробностей */
const actualGuids = (spending: TStringMap<any>) => actualsOf(spending).map((a) => a.guid)

/** Оплаты, у которых нет планового платежа в этой строке */
const orphanActualPayments = (spending: TStringMap<any>) => {
  const plans = new Set<string>((spending[fields.planPayments] || []).map((p: any) => p.guid))

  return actualsOf(spending).filter((a) => !a.planPaymentGuid || !plans.has(a.planPaymentGuid))
}

interface ActualPaymentsProps {
  data: ActualPaymentSnapshotType[]
  highlighted: string
  spendingId: string
  actualGuids: string[]
  saver: SpendingSaver
}

class ActualPayments extends React.PureComponent<ActualPaymentsProps> {
  render() {
    const { data, highlighted, spendingId, actualGuids, saver } = this.props

    if (data.length === 0) {
      return null
    }

    return (
      <div className={styles.actuals}>
        <div className={styles.paymentsName}>{ACTUAL_PAYMENTS_BLOCK_NAME} без планового платежа</div>
        {data.map((payment) => (
          <div
            key={payment.guid}
            className={`${styles.orphanFact} ${highlighted === payment.guid ? "payment-row-highlighted" : ""}`}
          >
            <ActualPaymentMark actual={payment} spendingId={spendingId} actualGuids={actualGuids} saver={saver} />
          </div>
        ))}
      </div>
    )
  }
}

interface TaskStateProps {
  spending: TStringMap<any>
  onChange: (field: string, value: any) => void
  readOnly?: boolean
}

export class TaskState extends React.PureComponent<TaskStateProps> {
  render() {
    const { spending, readOnly } = this.props

    const issued = !!spending[fields.taskIssued]
    const completed = !!spending[fields.taskCompleted]
    const accepted = !!spending[fields.taskAccepted]

    // кнопки остаются цветными (цвет — это само состояние задания), поэтому о том,
    // что менять статус нельзя, сообщаем подсказкой
    const hint = (label: string) => (readOnly ? `${label}: изменение недоступно` : label)

    return (
      <div>
        <span>Статус</span>
        <div className="status-doc">
          <PlanrPopover
            placement="right"
            isOpen={undefined}
            interactionKind="hover"
            content={
              issued ? (
                <div style={{ padding: "7px" }}>
                  <div className={`${Classes.INPUT_GROUP} `}>
                    <DatePicker
                      rootBoundary="viewport"
                      value={moment(spending[fields.taskIssuedDate], DATE_FORMAT).toDate()}
                      onChange={this.issuedDateChange}
                      clasName="planr-default-input"
                    />
                  </div>
                </div>
              ) : undefined
            }
          >
            <PlanrButton
              icon="general-doc-arrow-right"
              type={issued ? "blueish" : "graybtn"}
              round={true}
              onClick={() => {
                this.issuedChange()
                //  this.issuedDateChange();
              }}
              title={hint(labels[fields.taskIssued])}
            />
          </PlanrPopover>
        </div>
        <div className="status-doc">
          <PlanrPopover
            placement="right"
            isOpen={undefined}
            interactionKind="hover"
            content={
              completed ? (
                <div style={{ padding: "7px" }}>
                  <div className={`${Classes.INPUT_GROUP} `}>
                    <DatePicker
                      rootBoundary="viewport"
                      value={moment(spending[fields.taskCompletedDate], DATE_FORMAT).toDate()}
                      onChange={this.completedDateChange}
                      clasName="planr-default-input"
                    />
                  </div>
                </div>
              ) : undefined
            }
          >
            <PlanrButton
              icon="general-doc-check"
              type={completed ? "blueish" : "graybtn"}
              round={true}
              onClick={() => {
                this.completedChange()
                //
              }}
              title={hint(labels[fields.taskCompleted])}
            />
          </PlanrPopover>{" "}
        </div>
        <div className="status-doc">
          <PlanrPopover
            placement="right"
            isOpen={undefined}
            interactionKind="hover"
            content={
              accepted ? (
                <div style={{ padding: "7px" }}>
                  <div className={`${Classes.INPUT_GROUP} `}>
                    <DatePicker
                      rootBoundary="viewport"
                      value={moment(spending[fields.taskAcceptedDate], DATE_FORMAT).toDate()}
                      onChange={this.acceptedDateChange}
                      clasName="planr-default-input"
                    />
                  </div>
                </div>
              ) : undefined
            }
          >
            <PlanrButton
              icon="general-check"
              type={accepted ? "greenish" : "graybtn"}
              round={true}
              onClick={() => {
                this.acceptedChange()
              }}
              title={hint(labels[fields.taskAccepted])}
            />
          </PlanrPopover>
        </div>
      </div>
    )
  }

  onChange = (field: string) => () => {
    const { spending, onChange, readOnly } = this.props

    const value = !!spending[field]
    !readOnly && onChange(field, !value)
  };

  /** Дата статуса меняется только там, где разрешено менять и сам статус */
  onDateChange = (field: string) => (date: Date | null) => {
    const { onChange, readOnly } = this.props

    !readOnly && onChange(field, date ? moment(date).local().format(DATE_FORMAT) : null)
  };

  issuedChange = this.onChange(fields.taskIssued);
  issuedDateChange = this.onDateChange(fields.taskIssuedDate);

  completedDateChange = this.onDateChange(fields.taskCompletedDate);

  acceptedDateChange = this.onDateChange(fields.taskAcceptedDate);

  completedChange = this.onChange(fields.taskCompleted);

  acceptedChange = this.onChange(fields.taskAccepted);
}

interface OrderSumProps {
  spending: TStringMap<any>
  onChange: (field: string, value: any) => void
  readOnly?: boolean
  children?: React.ReactNode;
  /** подсветка суммы, если она не совпадает с плановыми оплатами */
  sumClassName?: string
  /** подсветка остатка, если работа принята, а оплачена не полностью */
  restClassName?: string
}

export class OrderSum extends React.PureComponent<OrderSumProps> {
  render() {
    const { spending, readOnly, children, sumClassName, restClassName } = this.props

    return (
      <div className={styles.orderSum}>
        <div className={sumClassName}>
          <label className={styles.labelSum}>{labels[fields.actualSum]}:</label>
          <MoneyInput
            className="planr-default-input"
            value={spending[fields.actualSum]}
            onMoneyChange={this.onChange}
            autoComplete="off"
            data-lpignore="true"
            onKeyDown={preventSubmitKeyDown}
            disabled={readOnly}
          />
        </div>
        <div className={restClassName}>
          <label className={styles.labelSum}>Остаток:</label>
          <MoneyInput
            className="planr-default-input"
            value={`${getDebit(spending as any, "actual")}`}
            disabled={true}
            onMoneyChange={eat}
          />
        </div>
        {children}
      </div>
    )
  }

  onChange = (money: NumberFormatValues) => {
    if (!this.props.readOnly) {
      this.props.onChange(fields.actualSum, money.value)
    }
  };
}

interface PlanPaymentsProps extends PaymentStatusToggler, UploaderFatory {
  value: OutsourcerPaymentType[]
  /** фактические оплаты строки: каждая закрывает ровно один плановый платёж */
  actualPayments?: ActualPaymentSnapshotType[]
  factory: OutsourcerPaymentFactory
  title?: string
  onChange: (value: OutsourcerPaymentSnapshotType[]) => void
  readOnly?: boolean
  baseUrl: string
  outsourcer: string
  details: OrderSummaryType
  newIdd: () => Promise<string>
  dirty: boolean
  allPayments: ActualPaymentType[]
  spendingId: string
  spendingRow: TStringMap<any>
  highlighted: string
  saver: SpendingSaver
  section: string
}

interface PlanPaymentsState {
  /** оплата, добавленная только что: открываем её сразу на редактирование */
  addedGuid: string
}

export class PlanPayments extends React.Component<PlanPaymentsProps, PlanPaymentsState> {
  constructor(props: PlanPaymentsProps) {
    super(props)

    this.state = { addedGuid: "" }
  }

  render() {
    const {
      value,
      title,
      readOnly,
      formDirty,
      toggleStatus,
      upload,
      baseUrl,
      outsourcer,
      details,
      newIdd,
      dirty,
      allPayments,
      spendingId,
      highlighted,
    } = this.props
    const actuals = this.props.actualPayments || []
    const guids = actuals.map((a) => a.guid)

    return (
      <div className={styles.plan}>
        <div className={styles.paymentsName}>{title || PLAN_PAYMENTS_BLOCK_NAME}</div>
        <div className={styles.table}>
          {value.map((payment) => (
            <PlanPaymentRow
              key={payment.guid}
              onChange={(field1, text1, field2, text2, field3, text3, field4, text4, field5, text5) => {
                this.onPaymentChange(payment, field1, text1, field2, text2, field3, text3, field4, text4, field5, text5)
              }}
              onChangeInvoice={(field, text) => {
                this.onPaymentInvoiceChange(payment, field, text)
              }}
              newIdd={newIdd}
              onRemove={this.removePayment}
              payment={payment}
              actual={actuals.find((a) => a.planPaymentGuid === payment.guid)}
              actualGuids={guids}
              readOnly={readOnly}
              toggleStatus={toggleStatus}
              formDirty={formDirty}
              upload={upload}
              baseUrl={baseUrl}
              outsourcer={outsourcer}
              details={details}
              dirty={dirty}
              allPayments={allPayments}
              spendingId={spendingId}
              spendingRow={this.props.spendingRow}
              // на редактирование открывается только оплата, которой ещё нет на сервере:
              // при сохранении оплаты в новой строке форма пересобирается дважды, оплата
              // успевает пропасть и появиться, и сохранённая иначе открывалась бы заново
              autoEdit={
                payment.guid === this.state.addedGuid &&
                !this.props.saver.paymentSaved(this.props.section, spendingId, payment.guid)
              }
              highlighted={highlighted}
              saver={this.props.saver}
              section={this.props.section}
            />
          ))}
        </div>
        {!readOnly && (
          <PlanrButton
            icon="general-plus-big"
            type="dashed"
            onClick={this.addPayment}
            style={{ width: "100%", marginTop: "16px" }}
          >
            Добавить оплату
          </PlanrButton>
        )}
      </div>
    )
  }

  onPaymentChange = (
    payment: OutsourcerPaymentType,
    field1: string,
    text1: any,
    field2: string,
    text2: any,
    field3: string,
    text3: any,
    field4: string,
    text4: any,
    field5: string,
    text5: any
  ) => {
    const { value, onChange } = this.props
    // ищем по guid, а не по ссылке: пока оплата уходила на сервер, форма могла
    // пересобрать значения, и indexOf вернул бы -1 — массив склеивался с дублями
    const index = findIndex(value, (o) => o.guid === payment.guid)

    if (index < 0) {
      return
    }

    const newValue = [
      ...value.slice(0, index),
      { ...value[index], [field1]: text1, [field2]: text2, [field3]: text3, [field4]: text4, [field5]: text5 },
      ...value.slice(index + 1),
    ]
    onChange(newValue)
  };

  onPaymentInvoiceChange = (payment: OutsourcerPaymentType, field1: string, text1: any) => {
    const { value, onChange } = this.props
    const index = findIndex(value, (o) => o.guid === payment.guid)

    if (index < 0) {
      return
    }

    const newValue = [...value.slice(0, index), { ...value[index], [field1]: text1 }, ...value.slice(index + 1)]
    onChange(newValue)
  };

  addPayment = async () => {
    const { onChange, value } = this.props
    const payment = await this.props.factory.emptyOutsourcerPayment(value.length + 1)
    const newValue = [...value, payment]

    // сразу открываем новую оплату на редактирование: заполнять её всё равно придётся
    this.setState({ addedGuid: payment.guid })

    onChange(newValue)
  };

  removePayment = (guid: string) => {
    const { onChange, value } = this.props
    const index = findIndex(value, (o) => o.guid === guid)

    if (index >= 0) {
      const newValue = [...value.slice(0, index), ...value.slice(index + 1)]
      onChange(newValue)
    }
  };
}

export interface OutsourcerPaymentFactory {
  emptyOutsourcerPayment: (index: number) => Promise<ActualPaymentSnapshotType>
}

interface PlanPaymentRowProps extends PaymentStatusToggler, UploaderFatory {
  dirty: boolean
  highlighted: string
  payment: TStringMap<any>
  /** фактическая оплата этого платежа */
  actual?: ActualPaymentSnapshotType
  actualGuids: string[]
  readOnly?: boolean
  onChange: (
    field1: string,
    value1: any,
    field2: string,
    value2: any,
    field3: string,
    value3: any,
    field4: string,
    value4: any,
    field5: string,
    value5: any
  ) => void
  onChangeInvoice: (field: string, value: any) => void
  newIdd: () => Promise<string>
  onRemove: (guid: string) => void
  baseUrl: string
  outsourcer: string
  details: OrderSummaryType
  allPayments: ActualPaymentType[]
  spendingId: string
  spendingRow: TStringMap<any>
  saver: SpendingSaver
  section: string
  /** оплата только что добавлена — открываем её сразу на редактирование */
  autoEdit?: boolean
}

interface PlanPaymentRowState {
  loading: boolean
  eventDates: EventDateType[]
  mode: "date" | "event"
  active: boolean
  error: string
  money: string
  date: Date | null
  comment: string
  /** идёт отправка оплаты на сервер — второй раз жать нельзя */
  saving: boolean
}

type FileType = {
  fileId: string
  fileName: string
}
export class PlanPaymentRow extends React.PureComponent<PlanPaymentRowProps, PlanPaymentRowState> {
  constructor(props: PlanPaymentRowProps) {
    super(props)

    this.state = {
      loading: false,
      eventDates: [],
      mode: "date",
      active: false,
      money: "",
      date: null,
      error: "",
      comment: "",
      saving: false
    }
  }

  componentDidMount() {
    if (this.props.payment[outsourcerPaymentFields.eventDates].length > 0) {
      this.setState({ mode: "event" })
    } else {
      this.setState({ mode: "date" })
    }

    if (this.props.autoEdit) {
      this.edit()
    }
  }

  /** Открыть оплату на редактирование, подставив её текущие значения */
  edit = () => {
    const { payment } = this.props

    this.setState({
      active: true,
      money: payment[outsourcerPaymentFields.sum],
      date: payment[outsourcerPaymentFields.concreteDate]
        ? moment(payment[outsourcerPaymentFields.concreteDate], "DD.MM.YYYY").toDate()
        : null,
      eventDates: payment[outsourcerPaymentFields.eventDates],
      comment: payment[outsourcerPaymentFields.comment],
    })
  };
  render() {
    const { readOnly, payment, outsourcer, baseUrl, details, newIdd, dirty, allPayments, highlighted, actual } = this.props
    let file: FileType | null = null

    if (payment[outsourcerPaymentFields.invoice]) {
      file = {
        fileId: payment[outsourcerPaymentFields.invoice].fileId,
        fileName: payment[outsourcerPaymentFields.invoice].fileName,
      }
    }
    const date = payment[outsourcerPaymentFields.hasDate] ? payment[outsourcerPaymentFields.hasDate] : ""
    const knownDate = date && date !== payment[outsourcerPaymentFields.dateDescription] ? date : null

    const sum = formatMoney(payment[outsourcerPaymentFields.sum])
    const comment = payment[outsourcerPaymentFields.comment]
    const description =
      this.state.eventDates.length > 0 && dirty
        ? this.state.eventDates.map((e) => e.model.type)
        : this.state.date !== null && dirty
          ? moment(this.state.date).format(DATE_FORMAT)
          : payment[outsourcerPaymentFields.dateDescription]
    return (
      <div
        className={`${styles.planRow} ${actual ? styles.planRowPaid : ""} ${
          highlighted &&
          (highlighted === payment[outsourcerPaymentFields.guid] || highlighted === actual?.guid) &&
          styles.highlighted
        }`}
        data-object-id={payment[outsourcerPaymentFields.guid]}
      >
        <div className={styles.btn}>
          {this.state.active && !readOnly && (
            <div>
              <GeneralIcon
                style={{
                  cursor: this.state.saving ? "default" : "pointer",
                  color: this.state.saving ? "rgba(29, 210, 120, 0.4)" : "#1dd278"
                }}
                type="general-redo"
                title="Сохранить оплату"
                onClick={() => {
                  if (!this.state.saving) {
                    this.savePayment()
                  }
                }}
              />
            </div>
          )}
          {!this.state.active && !readOnly && (
            <div>
              <GeneralIcon
                type="general-edit"
                style={{ cursor: "pointer", color: "#36acd7", marginLeft: "5px" }}
                onClick={this.edit}
              />
            </div>
          )}
        </div>
        {!this.state.active && (
          <div className={styles.paymentInfo}>
            <div style={{ marginBottom: "5px" }}>Платеж №{payment[outsourcerPaymentFields.name]}</div>
            <PlanrTag
              // type={"neutral"}
              type={
                payment[outsourcerPaymentFields.status] === Constants.orderPaymentStatusPaid ? "success" : "neutral"
              }
              style={{ marginBottom: "5px" }}
            >
              {sum}
            </PlanrTag>
            <div style={{ marginBottom: "5px", textAlign: "center" }}>
              {knownDate && (
                <Tooltip content={knownDate} position={Position.TOP}>
                  <span className={Classes.TOOLTIP_INDICATOR}>{description}</span>
                </Tooltip>
              )}
              {!knownDate && description}
              {!description && <PlanrTag type={"danger"}>Укажите дату или событие</PlanrTag>}
            </div>
            <div style={{ marginBottom: "5px", textAlign: "center", color: "#797979" }}>
              {comment}
            </div>
          </div>
        )}
        {this.state.active && (
          <div className={styles.paymentBlock}>
            <div style={{ color: "red", fontSize: "12px" }}>{this.state.error}</div>
            <div className={styles.flexRow}>
              <div className={styles.sumTop}>Сумма:</div>
              <MoneyInput
                className="planr-default-input"
                value={this.state.money}
                onMoneyChange={this.onSumChanged}
                autoComplete="off"
                data-lpignore="true"
                onKeyDown={preventSubmitKeyDown}
              />
              {/* {readOnly && (
            <div className="centered">
              <Money amount={payment[outsourcerPaymentFields.sum]} noFraction={true} />
            </div>
          )} */}
            </div>
            <div className={styles.flexRow}>
              <PlanrButton
                type={this.state.mode === "event" ? "lightblueish" : "blueish"}
                size="small"
                onClick={() => {
                  this.setState({ mode: "date" })
                }}
                style={{ height: "25px", width: "50%" }}
              >
                Дата
              </PlanrButton>
              <PlanrButton
                type={this.state.mode === "date" ? "lightblueish" : "blueish"}
                style={{ marginLeft: "0px", height: "25px", width: "50%" }}
                size="small"
                onClick={() => {
                  this.setState({ mode: "event" })
                }}
              >
                Событие
              </PlanrButton>
            </div>
            <div className={styles.flexRow}>
              <div className={styles.dateEvent}>
                {this.state.mode === "date" && (
                  <div className={`${Classes.INPUT_GROUP} `}>
                    <DatePicker
                      rootBoundary="viewport"
                      value={this.state.date}
                      onChange={this.onDateChanged}
                      clasName="planr-default-input"
                    />
                  </div>
                )}
                {this.state.mode === "event" && (
                  <div>
                    {this.state.eventDates.map((event, index) => {
                      const eventType = Constants.businessEventTypesOptions.find((o) => o.id === event.model.type)
                      const readonly = !!event.eventId
                      const daysCountValue = event.daysCount === 0 ? "" : event.daysCount.toString()
                      const Component = SpendingComponents.find((c) => c.TYPE === event.model.type) ?? UnknownEventType
                      return (
                        <div className={styles.event} key={index}>
                          <div>
                            <RemoveConfirmation<EventDateType>
                              what={() => "Событие"}
                              actionName="отвязать"
                              render={({ confirmRemoving }) => (
                                <PlanrButton
                                  type="secondary"
                                  icon="general-trash"
                                  onClick={() => confirmRemoving(event)}
                                  size="small"
                                  title={texts.remove}
                                  style={{ marginBottom: "5px", width: "100%" }}
                                  className={styles.deleteButton}
                                >
                                  Отвязать событие
                                </PlanrButton>
                              )}
                              onConfirmed={() => {
                                const newEvents = this.state.eventDates.filter(
                                  (ev) => ev.model.newId !== event.model.newId
                                )
                                this.setState({ eventDates: newEvents })
                              }}
                            />
                          </div>

                          <div className={`${Classes.INPUT_GROUP}`} style={{ marginBottom: "5px" }}>
                            <SimpleSelect
                              className={`full-width-select ${Classes.FILL}`}
                              filterable={false}
                              activeItem={eventType}
                              items={Constants.businessEventTypesOptions}
                              itemRenderer={renderSingleOption}
                              onItemSelect={(i: SelectItem) => {
                                let newEvents = [...this.state.eventDates]
                                let index = newEvents.findIndex((ev) => ev.model.newId === event.model.newId)
                                if (index > -1) {
                                  let model = { ...newEvents[index].model }
                                  model.type = i.id
                                  newEvents[index] = { ...newEvents[index], model }
                                  this.setState({ eventDates: newEvents })
                                }
                              }}
                              disabled={readonly}
                              popoverProps={{
                                popoverClassName: "business-event__break-dropdown",
                                usePortal: true,
                              }}
                            >
                              {readonly && <Button fill={true} className="selected-option" text={eventType?.label} />}
                              {!readonly && (
                                <DefaultSelectedOption
                                  option={eventType}
                                  empty={!Constants.businessEventTypesOptions.length}
                                />
                              )}
                            </SimpleSelect>
                          </div>

                          <Component
                            event={event}
                            payments={details.planPayments}
                            stages={details.stageItems}
                            spendings={allPayments.filter((p) => p.guid !== payment[outsourcerPaymentFields.guid])}
                            readonly={readonly}
                            additions={details.additions}
                            isNotStateChange={(field: string, val: any) => {
                              this.onChangeEvent(event, field, val)
                            }}
                          />

                          <div style={{ display: "flex", alignItems: "center", marginTop: "5px" }}>
                            <div className={Classes.LABEL}>Через:&nbsp;</div>
                            <InputGroup
                              id="offcet"
                              value={daysCountValue}
                              type="text"
                              className="planr-default-input"
                              autoComplete="off"
                              data-lpignore="true"
                              onKeyPress={digits}
                              style={{ width: "135px" }}
                              onChange={(e: any) => {
                                let newEvents = [...this.state.eventDates]
                                let index = newEvents.findIndex((ev) => ev.model.newId === event.model.newId)
                                if (index > -1) {
                                  newEvents[index] = { ...newEvents[index], daysCount: e.currentTarget.value }
                                  this.setState({ eventDates: newEvents })
                                }
                              }}
                            />
                            &nbsp;
                            <GeneralIcon
                              type={event.workDays ? "general-checkbox" : "general-zero-checkbox"}
                              onClick={(e: any) => {
                                let newEvents = [...this.state.eventDates]
                                let index = newEvents.findIndex((ev) => ev.model.newId === event.model.newId)
                                if (index > -1) {
                                  newEvents[index] = { ...newEvents[index], workDays: !event.workDays }
                                  this.setState({ eventDates: newEvents })
                                }
                              }}
                              size={16}
                              style={{ cursor: "pointer" }}
                            />
                            <div className={Classes.LABEL}>&nbsp;раб.дней</div>
                            {/* <Checkbox
                              large={false}
                              checked={event.workDays}
                              onChange={(e: any) => {
                                let newEvents = [...this.state.eventDates];
                                let index = newEvents.findIndex((ev) => ev.eventId === event.eventId);
                                if (index > -1) {
                                  newEvents[index] = { ...newEvents[index], workDays: e.currentTarget.checked };
                                  this.setState({ eventDates: newEvents });
                                }
                              }}
                              label="раб.дней"
                            /> */}
                          </div>
                        </div>
                      )
                    })}
                    <PlanrButton
                      type="lightgreenish"
                      onClick={async () => {
                        const newEv: any = {
                          daysCount: 0,
                          workDays: false,
                          model: {
                            id: "",
                            newId: await newIdd(),
                            paymentGuid: "",
                            stageGuid: "",
                            status: "",
                            type: Constants.businessEventTypes[0],
                            belonging: [],
                            additionalText: "",
                            additionNumber: "",
                          },
                        }
                        let oldEvents = [...this.state.eventDates]
                        oldEvents.push(newEv)
                        this.setState({ eventDates: oldEvents })
                      }}
                      style={{ width: "100%" }}
                      size="small"
                      className={styles.addButton}
                    >
                      {texts.add} событие
                    </PlanrButton>
                  </div>
                )}
                {/* <PlanrButton type={"greenish"} icon={"general-save"} onClick={this.onDateChangeHandler} /> */}
              </div>

              {/* {readOnly && <div className="centered">{formatDate(payment[outsourcerPaymentFields.date])}</div>} */}
            </div>
            <div className={styles.flexRow} style={{ alignItems: "flex-start" }}>
              <div className={styles.sumTop} style={{ marginTop: "5px" }}>Примеч:</div>
              {/* <InputGroup
                value={this.state.comment}
                onChange={(e: any) => {

                  this.setState({ comment: e.currentTarget.value })
                }
                }
                className="planr-default-input"
                autoComplete="off"
                small
              /> */}
              <div className={`${Classes.INPUT_GROUP} planr-default-input`}>
                <TextArea
                  value={this.state.comment}
                  onChange={(e: any) => {

                    this.setState({ comment: e.currentTarget.value })
                  }
                  }
                  autoResize={true}
                  className={Classes.FILL}
                />
              </div>
            </div>
          </div>
        )}

        {this.state.active && (
          <div className={styles.btn} style={{ width: "22px", marginLeft: "10px" }}>
            <GeneralIcon
              style={{ cursor: "pointer", color: "#ea561e" }}
              type="general-undo"
              onClick={() => {
                this.setState({ active: false })
              }}
            />
          </div>
        )}

        {!this.state.active && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div className="centered">{outsourcer && this.statusButton()}</div>
            <div className="centered">
              {!readOnly && !payment[outsourcerPaymentFields.invoice] && !this.state.loading && (
                <FileUploaderHOC
                  accept={"*"}
                  onFileSelected={this.uploadInvoiceFile}
                  render={({ onClick }) => (
                    <GeneralIcon
                      onClick={onClick}
                      type="general-attach"
                      title="Прикрепить счет"
                      style={{ cursor: "pointer", marginLeft: `${!file ? "20px" : "0px"}` }}
                    />
                  )}
                />
              )}
              {!readOnly && !payment[outsourcerPaymentFields.invoice] && this.state.loading && (
                <div className="uploader-icon">{<Spinner intent="primary" size={16} />}</div>
              )}
              {payment[outsourcerPaymentFields.invoice] && (
                <div className={styles.invoiceUploaded}>
                  <GeneralIcon
                    onClick={this.onInvoiceRemove}
                    type="general-un-attach"
                    style={{ color: "#1DD278", cursor: "pointer", marginRight: "10px" }}
                    title="Открепить счет"
                  />
                  <div style={{ marginTop: "4px", width: "20px" }}>
                    {file && (
                      <FileLink<any>
                        key={file.fileId}
                        baseUrl={baseUrl}
                        file={file}
                        readOnly={true}
                        onRemove={eat}
                        littleIcon
                        title={file.fileName}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div>
              {!readOnly && (
                <RemoveConfirmation
                  onConfirmed={this.onRemove}
                  what={() => "оплату"}
                  render={({ confirmRemoving }) => {
                    return (
                      <GeneralIcon
                        onClick={confirmRemoving}
                        type="general-trash"
                        style={
                          file != null
                            ? { marginTop: "1px", color: "#E31818", cursor: "pointer", marginLeft: "15px" }
                            : { marginTop: "1px", color: "#E31818", cursor: "pointer", marginLeft: "25px" }
                        }
                        title={texts.remove}
                      />
                    )
                  }}
                />
              )}
              {payment[outsourcerPaymentFields.automatic] && (
                <Icon icon="lock" htmlTitle="Создано автоматически" size={LARGE_ICON_AS_BUTTON_SIZE} />
              )}
            </div>
          </div>
        )}

        {/* факт оплаты — полосой во всю ширину карточки */}
        {actual && !this.state.active && (
          <div className={styles.planRowFact}>
            <ActualPaymentMark
              actual={actual}
              planSum={+payment[outsourcerPaymentFields.sum]}
              spendingId={this.props.spendingId}
              actualGuids={this.props.actualGuids}
              saver={this.props.saver}
            />
          </div>
        )}
      </div>
    )
  }

  savePayment = async () => {
    if (this.state.money === null || this.state.money === "") {
      this.setState({ error: "Необходимо указать сумму!" })
      return
    }
    if (+this.state.money === 0) {
      this.setState({ error: "Сумма должна быть больше 0!" })
      return
    }

    if (this.state.date === null && this.state.eventDates.length === 0) {
      this.setState({ error: "Необходимо указать дату или событие!" })
      return
    }
    let err = false
    if (this.state.eventDates.length > 0) {
      this.state.eventDates.forEach((e) => {
        if (e.model.type === EventTypes.AdditionBusinessEvent && e.model.additionNumber === "") {
          err = true
        }
        if (e.model.type === EventTypes.ChangeStatusBusinessEvent && e.model.status === "") {
          err = true
        }
        if (
          (e.model.type === EventTypes.ConsignmentBusinessEvent ||
            e.model.type === EventTypes.ExpertiseBusinessEvent ||
            e.model.type === EventTypes.SentExpertiseBusinessEvent ||
            e.model.type === EventTypes.IpdFileBusinessEvent ||
            e.model.type === EventTypes.OrderStageCompletedBusinessEvent ||
            e.model.type === EventTypes.OrderStageStartedBusinessEvent) &&
          e.model.stageGuid === ""
        ) {
          err = true
        }
        if (
          (e.model.type === EventTypes.OrderPaymentBusinessEvent ||
            e.model.type === EventTypes.OrderSpendingPaymentBusinessEvent) &&
          e.model.paymentGuid === ""
        ) {
          err = true
        }
      })
    }

    if (err) {
      return
    }
    if (this.props.payment[outsourcerPaymentFields.status] !== Constants.orderPaymentStatusPaid) {
      const concreteDate =
        this.state.date && this.state.eventDates.length === 0 ? moment(this.state.date).format(DATE_FORMAT) : null
      const date = this.state.date ? this.state.date : new Date()
      const eventDates = this.state.eventDates.length > 0 ? this.state.eventDates : []

      // платёж уходит на сервер сам по себе: соседние платежи и фактические оплаты
      // при этом не переписываются
      const { saver, section, spendingRow, payment } = this.props

      this.setState({ saving: true, error: "" })

      const saved = await saver.savePaymentIn(section, spendingRow, {
        ...payment,
        [outsourcerPaymentFields.sum]: this.state.money,
        [outsourcerPaymentFields.concreteDate]: concreteDate,
        [outsourcerPaymentFields.date]: date,
        [outsourcerPaymentFields.eventDates]: eventDates,
        [outsourcerPaymentFields.comment]: this.state.comment,
      })

      this.setState({ saving: false })

      // сервер отказал — чаще всего оплату уже изменил кто-то другой. Форму не трогаем
      // и остаёмся в режиме редактирования: введённое не должно пропасть, а показанное
      // значение не должно расходиться с тем, что лежит на сервере
      if (!saved) {
        return
      }

      // в форму изменения попадают только после успешного ответа
      this.props.onChange(
        outsourcerPaymentFields.sum,
        this.state.money,
        outsourcerPaymentFields.concreteDate,
        concreteDate,
        outsourcerPaymentFields.date,
        date,
        outsourcerPaymentFields.eventDates,
        eventDates,
        outsourcerPaymentFields.comment,
        this.state.comment
      )
    }

    this.setState({ active: false })
  };

  uploadInvoiceFile = async (file: File) => {
    this.setState({ loading: true })
    const meta = await this.props.upload(file)

    if (meta) {
      const data: InvoiceFileSnapshotType = {
        ...meta,
      }

      await this.saveInvoice(data)
    }
    this.setState({ loading: false })
  };

  onInvoiceRemove = () => this.saveInvoice(null);

  /**
   * Счёт прикрепляют прямо в строке, без режима редактирования, а общей кнопки сохранения
   * у состава затрат больше нет: платёж сохраняется точечно. Поэтому отправляем счёт сразу,
   * иначе он остаётся только в форме и пропадает после перезагрузки
   */
  saveInvoice = async (invoice: InvoiceFileSnapshotType | null) => {
    const { saver, section, spendingRow, spendingId, payment } = this.props

    // платёж ещё не на сервере — счёт уйдёт вместе с ним по кнопке сохранения платежа
    if (!saver.paymentSaved(section, spendingId, payment.guid)) {
      this.props.onChangeInvoice(outsourcerPaymentFields.invoice, invoice)
      return
    }

    const saved = await saver.savePaymentIn(section, spendingRow, {
      ...payment,
      [outsourcerPaymentFields.invoice]: invoice,
    })

    if (!saved) {
      return
    }

    // сервер закрепляет файл за платежом и возвращает его уже в своём виде: в форму кладём
    // именно его, иначе платёж будет считаться несохранённым и заблокирует запрос на оплату
    const row = saver.formValues(section, spendingRow)
    const fresh = row?.planPayments.find((p: any) => p.guid === payment.guid)

    const stored = fresh ? fresh[outsourcerPaymentFields.invoice] : invoice

    this.props.onChangeInvoice(outsourcerPaymentFields.invoice, stored)
  };

  onSumChanged = (money: NumberFormatValues) => this.setState({ money: money.value });
  onChangeEvent = (event: EventDateType, field: string, value: any) => {
    let newEvents = [...this.state.eventDates]
    let index = newEvents.findIndex((ev) => ev.model.newId === event.model.newId)
    if (index > -1) {
      let model = { ...newEvents[index].model }
      switch (field) {
        case "status": {
          model.status = value
          break
        }
        case "statusSpending": {
          model.status = value
          model.secondId = this.props.spendingId
          break
        }
        case "type": {
          model.type = value
          break
        }
        case "paymentGuid": {
          model.paymentGuid = value
          break
        }
        case "stageGuid": {
          model.stageGuid = value
          break
        }
        case "additionNumber": {
          model.additionNumber = value
          break
        }
      }
      newEvents[index] = { ...newEvents[index], model }
      this.setState({ eventDates: newEvents })
    }
  };
  onDateChanged = (date: Date | null) => this.setState({ date: date });
  // onDateChangeHandler = () => {
  //   this.props.onChange(outsourcerPaymentFields.eventDates, this.state.eventDates);
  // };
  statusIcon = (status: string): GeneralIcons => {
    switch (status) {
      case Constants.orderPaymentStatusNew:
        return "general-question"
      case Constants.orderPaymentStatusAccepted:
        return "general-like"
      case Constants.orderPaymentStatusPaid:
        return "general-check"
      default:
        return "general-credit-card"
    }
  };

  statusButton = () => {
    const { payment, readOnly, saver, section, spendingId } = this.props
    const status: string = payment[outsourcerPaymentFields.status]
    const icon = this.statusIcon(status)

    const canBeToggled = ["", Constants.orderPaymentStatusCancelled]

    // запрос на оплату отправляется только по той оплате, которая уже уехала на сервер.
    // Раньше здесь стоял dirty всей формы, но с построчным сохранением он не сбрасывается
    // до перезагрузки страницы — смотрим на саму оплату
    const unsaved = saver.paymentChanged(section, spendingId, payment)

    if (readOnly || unsaved || !canBeToggled.includes(status)) {
      return (
        <GeneralIcon
          type={icon}
          style={
            status === Constants.orderPaymentStatusPaid
              ? { color: "#1DD278", cursor: "pointer", marginRight: "10px", marginLeft: "10px" }
              : { color: "rgba(0, 39, 61, 0.3)", cursor: "pointer", marginRight: "10px", marginLeft: "10px" }
          }
          title={status}
        />
      )
    }

    if (canBeToggled.includes(status)) {
      return (
        <GeneralIcon
          type={icon}
          onClick={this.toggleStatus}
          style={{ cursor: "pointer", marginRight: "10px", marginLeft: "10px" }}
          title={status || "Отправить запрос на оплату"}
        />
      )
    }

    return null
  };

  toggleStatus = async () => {
    const { payment, toggleStatus, onChangeInvoice } = this.props
    const id = payment[outsourcerPaymentFields.guid]

    if (!toggleStatus) {
      return
    }

    const status = await toggleStatus(id)

    // статус оплаты лежит и в форме: без этого иконка обновится только после перезагрузки
    if (typeof status === "string" && status) {
      onChangeInvoice(outsourcerPaymentFields.status, status)
    }
  };

  onRemove = async () => {
    const { saver, section, spendingId, payment, onRemove } = this.props

    const removed = await saver.removePayment(section, spendingId, payment)

    if (removed) {
      onRemove(payment[outsourcerPaymentFields.guid])
    }
  };
}
